import {IconCategoryPlus, IconTool} from '@tabler/icons-react';
import type {ReactNode} from 'react';
import type {TreeResponse} from 'src/api/ProactApiClient';
import {TreeResponseBrowser} from 'src/app/tree-browser/TreeResponseBrowser';
import {useGetAssetTreeQuery} from 'src/redux/queries/asset';
import {assetTreeKinds, assetTreeRootId} from './assetTreeBrowserState';

const assetGroupIcon = (
  <IconCategoryPlus size={14} color="var(--mantine-color-yellow-9)" />
);
const assetIcon = <IconTool size={14} />;
const assetIconsByKind = {
  [assetTreeKinds.group]: assetGroupIcon,
  [assetTreeKinds.asset]: assetIcon,
};

export interface AssetTreeBrowserProps {
  selectedId?: string;
  onSelect: (id: string, node?: TreeResponse) => void;
  children: ReactNode;
}

/** Asset group query adapter for the shared tree-response browser. */
export const AssetTreeBrowser = ({
  selectedId,
  onSelect,
  children,
}: AssetTreeBrowserProps) => {
  const query = useGetAssetTreeQuery({activeStates: [true]});

  return (
    <TreeResponseBrowser
      query={query}
      rootId={assetTreeRootId}
      rootLabel="All Assets"
      paneTitle="Assets"
      expansionKey="assets"
      selectedId={selectedId}
      onSelect={onSelect}
      icon={assetGroupIcon}
      iconsByKind={assetIconsByKind}
      searchPlaceholder="Search assets"
      emptyText="No assets found."
      unavailableItemName="asset"
      unavailableLabel="Unavailable asset"
      resetLabel="Show All Assets">
      {children}
    </TreeResponseBrowser>
  );
};
